import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { useBuilderProgress } from 'api/queries/digital-profile/useBuilderProgress'
import { useSkillById } from 'api/queries/marketing-capabilities/skills/useSkillById'
import arrowtIcon from 'assets/images/explore-learnings/arrow.svg'
import videoIcon from 'assets/images/explore-learnings/Online Video.svg'
import squaresIcon from 'assets/images/explore-learnings/squares.svg'
import { setExploreLearningsSkill, setExploreLearningsSkillNames, useExploreLearnings } from 'store/ExploreLearnings'
import { experienceProfileLink, sharepointLink } from 'utils/common'

import { SkillListPage } from './SkillListPage'
import { Button } from '../components/Button'
import { PractitionerCard } from '../components/PractitionerCard'
import { PractitionerModal } from '../components/PractitionerModal'
import { ResourceCard } from '../components/ResourceCard'
import { SkillCard } from '../components/SkillCard'
import SkillPageSearchHeader from '../components/SkillPageSearchHeader'
import { SkillTag } from '../components/SkillTag'
import UploadResourceCard from '../components/uploadResourceCard/UploadResourceCard'
import { UploadResourceModal } from '../components/uploadResourceCard/UploadResourceModal'
import { useSearchNavigation } from '../hooks/useSearchNavigation'

export const SkillPage = () => {
  const { section } = useParams<{ section: 'skills' | 'resources' | 'community' }>()
  const [currentPage, setCurrentPage] = useState<'skills' | 'resources' | 'community'>(section || 'skills')

  const { skillId } = useParams<{ skillId: string }>()
  const { data: experienceProfileProgress } = useBuilderProgress()
  const { exists } = experienceProfileProgress || { exists: false }
  const { data: skillData } = useSkillById({ params: skillId })
  const skill = skillData && 'name' in skillData ? skillData : null
  const search = useExploreLearnings(state => state.search)
  let navigate = useNavigate()
  const navigateToSkill = (skillId: string) => {
    navigate(`/explore-learnings/skill/${skillId}`)
  }
  useEffect(() => {
    setCurrentPage(section || 'skills')
  }, [section])

  useSearchNavigation(currentPage, { redirectFromSkillPage: true })

  const [selectedPractitioner, setSelectedPractitioner] = useState<any>(undefined)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  return (
    <>
      <SkillPageSearchHeader page={currentPage} search={search} />
      <div className="marketing-capabilities bg-[#fafafa]">
        <div className="max-w-[100vw] min-h-[80vh] overflow-hidden">
          {search ? (
            <SkillListPage />
          ) : (
            <div>
              <div
                style={{ backgroundImage: `url(${skill?.backgroundUrl})` }}
                className="py-8 px-20 bg-cover bg-no-repeat flex justify-between border-b border-solid border-[#D7D7D7]"
              >
                <div className="flex flex-col">
                  <Link to="/explore-learnings" className="midi-s mb-[18px] flex items-center">
                    <img src={arrowtIcon} className="inline mr-3" alt="Back arrow" /> Back{' '}
                  </Link>
                  <h1 className="display-4xl mb-2">{skill?.name}</h1>
                  <p className="body-s max-w-[598px]">{skill?.description}</p>
                </div>
                <img src={skill?.iconUrl} className="size-[162px]" alt="" />
              </div>
              <div className="w-[1120px] mx-auto pt-16 flex flex-col gap-y-12">
                {skill?.resourcesCategories && (
                  <div className="flex flex-wrap gap-x-8 gap-y-8 mb-16">
                    {skill?.resourcesCategories.map((category: any) =>
                      category.resources.map((resource: any) => (
                        <ResourceCard
                          title={resource.name}
                          link={resource.url}
                          description={resource.description}
                          skills={resource.skills}
                          timeToComplete={resource.readTime}
                          key={resource.name + resource.url}
                          isSkillPageCard={true}
                        />
                      )),
                    )}
                  </div>
                )}
              </div>

              {/* <!-- Upload Resource section --> */}

              <div className="w-[1120px] mx-auto">
                <UploadResourceCard onUploadClick={() => setIsUploadModalOpen(true)} />
                {isUploadModalOpen && (
                  <UploadResourceModal
                    onClose={() => setIsUploadModalOpen(false)}
                    onSuccess={() => {
                      setIsUploadModalOpen(false)
                    }}
                  />
                )}
              </div>

              {skill?.practitioners && skill?.practitioners.length > 0 ? (
                <div className="bg-[#F4F2EF] mt-16">
                  <div className="w-[1120px] mx-auto flex flex-col py-12">
                    <div className="flex justify-between mb-6">
                      <p className="midi-s max-w-[643px]">
                        Connect with experts who can guide your learning journey, you can email them <br /> or schedule
                        a session to clear up your questions.
                      </p>
                      <Button
                        text="See all"
                        type="secondary"
                        className="ml-2"
                        onClick={() => {
                          setExploreLearningsSkill([skillId as string])
                          if (skill?.name) {
                            setExploreLearningsSkillNames([skill.name])
                          }
                          navigate(`/explore-learnings/community?skills=${encodeURIComponent(skill.name || '')}`)
                        }}
                        icon={<img src={squaresIcon} alt="squares icon" className="ml-2" />}
                      />
                    </div>
                    <div className="flex flex-wrap gap-6">
                      {skill?.practitioners.map(practitioner => (
                        <div
                          className="cursor-pointer"
                          onClick={() => setSelectedPractitioner(practitioner)}
                          key={practitioner.id}
                        >
                          <PractitionerCard
                            imageUrl={practitioner.photoUrl}
                            name={`${practitioner.name} ${practitioner.surname}`}
                            email={practitioner.email}
                            role={practitioner.jobPosition}
                            location={practitioner.location}
                            key={practitioner.email}
                            tags={practitioner.skills}
                          />
                        </div>
                      ))}
                      {selectedPractitioner && (
                        <PractitionerModal
                          selectedPractitioner={selectedPractitioner}
                          onClose={() => setSelectedPractitioner(undefined)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {!exists ? (
                <div className="w-[1133px] mx-auto py-16">
                  <div className="flex justify-between">
                    <div className="w-[562px] h-[196px] flex p-6 bg-[#003735] rounded-3xl rounded-tr-none card-box-shadow">
                      <img
                        src={require('assets/images/explore-learnings/rocket.gif')}
                        alt="Rocket"
                        className="size-16 mr-6"
                      />
                      <div className="flex flex-col w-full">
                        <p className="text-white strong-l pb-2">Unlock personalized recommendations</p>
                        <p className="text-[#58BAB5] body-s mb-6">
                          Complete your self-assessment to get <br /> recommendations based on your profile.
                        </p>
                        <Link
                          className="w-[148px] strong-s self-end bg-white py-[9px] px-[18px] rounded-[40px] hover:bg-[#D4D4D4]"
                          to={experienceProfileLink}
                          rel="noopener noreferrer"
                        >
                          Take me there
                        </Link>
                      </div>
                    </div>
                    <div className="w-[562px] h-[196px] flex p-6 rounded-3xl rounded-tl-none card-box-shadow">
                      <img src={videoIcon} alt="Video" className="size-16 mr-6" />
                      <div className="flex flex-col w-full">
                        <p className="strong-l pb-2">AI Skill Pills</p>
                        <p className="body-s mb-6">
                          Discover how prepared you are for <br /> the AI revolution in marketing.
                        </p>
                        <Link
                          className="strong-s self-end text-white bg-black py-[9px] px-[18px] rounded-[40px] hover:bg-[#6E6E6E]"
                          to={sharepointLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Learn more
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-[1120px] mx-auto pb-16">
                  <div className="flex justify-between mb-9 mt-16">
                    <p className="heading-2xl">Skills picked just for you</p>
                    <div className="flex items-center">
                      <SkillTag skill={{ name: 'FROM YOUR EXPERIENCE PROFILE', color: '#D7D7D799' }} type="PAGE" />
                    </div>
                  </div>
                  <div className="flex justify-between">
                    {skill?.skillsPickedForYou &&
                      skill.skillsPickedForYou.map((skillItem: any) => {
                        return (
                          <div
                            onClick={() => {
                              window.scrollTo(0, 0)
                              navigateToSkill(skillItem.id)
                            }}
                            key={skillItem.id}
                          >
                            <SkillCard
                              key={skillItem.id}
                              name={skillItem.name}
                              image={skillItem.iconUrl}
                              type="BIG"
                              id={skillItem.id}
                              description={skillItem.description}
                            />
                          </div>
                        )
                      })}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
